import { DOCUMENT_ALLOWED_ORIGINS } from "config/api.config";

/**
 * Resolves a document path to a full URL and validates it against the
 * environment-specific allowlist of trusted origins.
 * Returns an empty string for any untrusted, non-https, or invalid URL
 * to prevent unsafe schemes from reaching native bridges or window.open.
 */
export const resolveDocumentUrl = (documentPath) => {
  if (!documentPath) return "";
  try {
    const resolved = new URL(documentPath, window.location.origin).href;
    const { origin } = new URL(resolved);

    if (origin === window.location.origin) {
      return resolved;
    }

    if (!resolved.startsWith("https://")) {
      console.error(`[documentUtils] Blocked non-https URL: ${resolved}`);
      return "";
    }
    if (!DOCUMENT_ALLOWED_ORIGINS.some((allowed) => origin === allowed)) {
      console.error(`[documentUtils] Blocked URL with non-whitelisted origin: ${origin}`);
      return "";
    }
    return resolved;
  } catch (_) {
    return "";
  }
};
